import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '../../app/api/apiSlice'

const capabilitiesTechAreaTypesAdapter = createEntityAdapter({})

const initialState = capabilitiesTechAreaTypesAdapter.getInitialState()

export const capabilitiesTechAreaTypesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCapabilitiesTechAreaTypes: builder.query({
            query: () => ({
                url: '/capabilitiesTechAreaTypes/getCapabilitiesTechAreaTypes',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedCapabilitiesTechAreaTypes = responseData.map(capabilitiesTechAreaType => {
                    capabilitiesTechAreaType.id = capabilitiesTechAreaType._id
                    return capabilitiesTechAreaType
                })
                return capabilitiesTechAreaTypesAdapter.setAll(initialState, loadedCapabilitiesTechAreaTypes)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'CapabilitiesTechAreaType', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'CapabilitiesTechAreaType', id}))
                    ]
                } else {
                    return [ { type: 'CapabilitiesTechAreaType', id: 'LIST'}]
                }
            },
        }),
        createNewCapabilitiesTechAreaType: builder.mutation({
            query: initialCapabilitiesTechAreaType => ({
                url: '/capabilitiesTechAreaTypes/createNewCapabilitiesTechAreaType',
                method: 'POST',
                body: {...initialCapabilitiesTechAreaType,}
            }),
            invalidatesTags: [
                { type: 'CapabilitiesTechAreaType', id: "LIST" }
            ] 
        }),
        updateCapabilitiesTechAreaType: builder.mutation({
            query: initialCapabilitiesTechAreaType => ({
                url: '/capabilitiesTechAreaTypes/updateCapabilitiesTechAreaType',
                method: 'PATCH',
                body: {...initialCapabilitiesTechAreaType,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'CapabilitiesTechAreaType', id: arg.id },
                { type: 'CapabilitiesTechAreaType', id: 'LIST' }
            ],
        }),
        deleteCapabilitiesTechAreaType: builder.mutation({
            query: ({id}) => ({
                url: '/capabilitiesTechAreaTypes/deleteCapabilitiesTechAreaType',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'CapabilitiesTechAreaType', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetCapabilitiesTechAreaTypesQuery,
    useCreateNewCapabilitiesTechAreaTypeMutation,
    useUpdateCapabilitiesTechAreaTypeMutation,
    useDeleteCapabilitiesTechAreaTypeMutation,
} = capabilitiesTechAreaTypesApiSlice

// returns the query result object
export const selectCapabilitiesTechAreaTypeResult = capabilitiesTechAreaTypesApiSlice.endpoints.getCapabilitiesTechAreaTypes.select()

// create memoized selector
const selectCapabilitiesTechAreaTypesData = createSelector(
    selectCapabilitiesTechAreaTypeResult,
    capabilitiesTechAreaTypeResult => capabilitiesTechAreaTypeResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllCapabilitiesTechAreaTypes,
    selectById: selectCapabilitiesTechAreaTypeById,
    selectIds: selectCapabilitiesTechAreaTypeIds,
} = capabilitiesTechAreaTypesAdapter.getSelectors(state => selectCapabilitiesTechAreaTypesData(state) ?? initialState)